import {
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
  Stack,
  FormLabel,
} from '@mui/material';
import React from 'react';

export const TextArea = ({
  id,
  label,
  placeholder,
  value,
  maxRows,
  minRows,
  onChange,
  ...props
}: MuiTextFieldProps) => {
  const labelId = `${id}-label`;

  return (
    <Stack spacing={1}>
      {label && <FormLabel id={labelId}>{label}</FormLabel>}
      <MuiTextField
        placeholder={placeholder}
        multiline
        maxRows={maxRows}
        minRows={minRows}
        value={value}
        onChange={onChange}
        {...props}
        label={undefined}
        slotProps={{
          ...props.slotProps,
          htmlInput: {
            ...props.slotProps?.htmlInput,
            ...(label ? { 'aria-labelledby': labelId } : undefined),
          },
        }}
      />
    </Stack>
  );
};
